<h3 class="service-map-title"><b>{{ title }}</b></h3>

<div class="service-map-container">
  <div class="service-map-wrapper" [style.height.px]="height">
    <div #mapContainer class="service-map-root"></div>
  </div>

  <div class="service-map-overlay" *ngIf="loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <div class="service-map-placeholder" *ngIf="!loading && markerCount === 0">
    No POP with geographic coordinates to display on the map.
  </div>
</div>
